export default class LoginModel {
    message: string
    status: boolean
    token: string
    user: UserModel
}

export class UserModel {
    email: string
    first_name: string
    group_permission: []
    id: number
    image: string
    job_title: string
    last_name: string
    middlename: string
    permission: []
    roles: string
    type: any
    username:string
    is_sales_person: boolean
    photo:string
    is_event_head:boolean
    phone_number:string
    country_code:number
}

export class PermissionsModel {
    action: string
    content_type: string
    id: number
    name: string
    selected: boolean = false
}

export class UserDetailModel {
    email: string
    name: string
    group_permission: []
    id: number
    image: string
    job_title: string
    permission: []
    roles: string
    type: any
    is_sales_person: boolean
    group:number[] = [];
    group_list: { id: number; name: string }[] = [];
    user_group: { id: number; name: string }[] = [];
}

export class UserResponseModel {
    count: number
    next: string
    previous: string
    results: UserDetailModel[]
}